/**
 * meta.js
 * Written by: Alex Kasemir
 */

import questionActions from 'store/question/actions';
import quizActions from 'store/quiz/actions';


/**
 * Description of the meta reducer
 */
const meta = (state = {}, action) => {
  switch (action.type) {
    case quizActions.GET_QUIZ_START:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          playthroughs: 0,
          correct: 0,
          loading: true,
          loaded: false,
          resultsLoading: false,
          resultsLoaded: false,
        },
      };
    case quizActions.GET_QUIZ_SUCCESS:
    case quizActions.GET_QUIZ_FAILURE:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          loading: false,
          loaded: true,
        },
      };
    case quizActions.GET_QUIZ_RESULTS_START:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          resultsLoading: true,
          resultsLoaded: false,
        },
      };
    case quizActions.GET_QUIZ_RESULTS_SUCCESS:
      if (action.results.attempted) {
        return {
          ...state,
          [action.id]: {
            ...state[action.id],
            resultsLoading: false,
            resultsLoaded: true,
            resultsError: false,
            playthroughs: action.results.attempted,
            correct: action.results.correct || 0,
          },
        };
      }
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          resultsLoading: false,
          resultsLoaded: true,
        },
      };
    case quizActions.GET_QUIZ_RESULTS_FAILURE:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          resultsLoading: false,
          resultsLoaded: true,
          resultsError: true,
        },
      };
    case questionActions.SUBMIT_QUESTION_SUCCESS:
      return {
        ...state,
        [action.result.quiz]: {
          ...state[action.result.quiz],
          playthroughs: state[action.result.quiz] ? state[action.result.quiz].playthroughs + 1 : 1,
          correct: action.result.played_answer.correct
            ? state[action.result.quiz] ? state[action.result.quiz].correct + 1 : 1
            : state[action.result.quiz] ? state[action.result.quiz].correct : 0,
        },
      };
    case quizActions.CLEAR_QUIZ_RESULTS:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          resultsLoaded: false,
        },
      };
    case `GET_TOP_USER_SUCCESS`:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          topUser: action.user.username,
        },
      };
    default:
      return state;
  }
};

export default meta;
